<template>
	<textarea class="base-textarea" />
</template>

<style lang="scss">
// .base-textarea {
// }
</style>
